import { CustomFormReport } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  customFormReport: CustomFormReport;
}

export interface InitCustomFormReportPreviewFilesSummarySectionResponseDataType {
  public_link_id: number;
  custom_form_report_id: number;
}

export const initCustomFormReportPdfPreviewFilesSummarySectionRequest = ({
                                                                           token,
                                                                           customFormReport,
                                                                         }: RequestParams): Promise<InitCustomFormReportPreviewFilesSummarySectionResponseDataType> => {
  const searchParameters = new URLSearchParams();
  searchParameters.set('custom_form_report', JSON.stringify(customFormReport));

  return ApiServiceInstance.makeRequest(`/custom-form-report/preview/init-files-summary-section?${ searchParameters.toString() }`, {
    method: 'GET',
    token,
  });
};